import { get, post } from './http'

export const api2 = p2 => get('https://xxx/v5/weather?city=taian&key=1b47b16e4aa545eaa55a66f859ac0089', p2)
export const api3 = p => post('https://xxx/svserver/upload/', p)

const getApiUrl = protocolName => {
  if (protocolName == 'https:') {
    return {
      'restaurant.fastorder.my': 'https://restaurant.fastorder.my',
      'merchant.fastorder.my': 'https://merchant.fastorder.my',
      'sandbox.fastorder.my': 'https://sandbox.fastorder.my',
      'fastorder.utools.club': 'https://fastorder.utools.club',
    }[location.hostname]
  } else {
    return {
      'restaurant.fastorder.my': 'http://restaurant.fastorder.my',
      'merchant.fastorder.my': 'https://merchant.fastorder.my',
      'sandbox.fastorder.my': 'https://sandbox.fastorder.my',
      'fastorder.utools.club': 'http://fastorder.utools.club',
      'local.fastorder.net': 'http://local.fastorder.net',
      'fastorder.ichehang.cn': 'http://fastorder.ichehang.cn',
    }[location.hostname]
  }
}
const apiBasicUrl = getApiUrl(document.location.protocol.toLowerCase())
export const getGoogleMapLocationPlace = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)

console.log({
  '当前环境为 ##': process.env.NODE_ENV,
  // 'apiBasicUrl': apiBasicUrl,
})

// http://restaurant.fastorder.my/app/index.php?i=2&c=entry&do=waplist&m=weisrc_dish&tablesid=263&storeid=44&mode=1&append=1&h5api=on
export const indexPage = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)

// http: //restaurant.fastorder.my/app/index.php?i=2&c=entry&storeid=44&from_user=ox5R_1eFnFRZ1J5PMrDV5FEDqq_o&do=UpdateDishNumOfCategory&m=weisrc_dish
// #说明 get部分 {i: 2  c: entry  storeid: 44  from_user: ox5R_1eFnFRZ1J5PMrDV5FEDqq_o  do :UpdateDishNumOfCategory  m: weisrc_dish  }
// #说明 post部分 {  dishid: 1242  optionid: 309  o2uNum: 1  optype: add}
export const updatedishnumofcategory = (apiName, apiParams) => post(apiBasicUrl + apiName, apiParams)

export const validateBusinessAndHoliday = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)

export const getDeliveryOption = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)

//http://restaurant.fastorder.my/app/index.php?i=2&c=entry&from_user=ox5R_1eFnFRZ1J5PMrDV5FEDqq_o&storeid=44&mode=1&tablesid=263&append=1&orderid=0&do=wapmenu&m=weisrc_dish
export const cartPage = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)

// 更新购物车
export const updateDishnumOfCategory = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)


// 确认订单并创建订单
export const addToOrder = (apiName, apiParams) => post(apiBasicUrl + apiName, apiParams)

// 清空购物车
export const clearCart = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)


// 清空购物车
export const getOrderDetail = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)

// 呼叫服务员
export const callAttendant = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)

// 404页面返回的信息
export const getStoreMessage = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)

// 检查sso登录
export const getXssoToken = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)
// 检查sso注销
export const ssoLogout = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)
// 检查是否有历史订单
export const checkHistoryExist = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)
// 获取用户的历史订单
export const getHistoryList = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)
// 获取商品详情数据
export const getGoodsDetail = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)

//获取 scene_code 的订单信息
export const getSceneCodeOrder = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)

//获取用户的地址列表
export const getAddressList = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)


//获取用户的地址列表
export const getAddressInfo = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)

//删除用户的地址
export const delAddressInfo = (apiName, apiParams) => post(apiBasicUrl + apiName, apiParams)

//保存更新用户的地址列表
export const saveAddressInfo = (apiName, apiParams) => post(apiBasicUrl + apiName, apiParams)

//delivery报价
export const getDeliveryQuotation = (apiName, apiParams) => post(apiBasicUrl + apiName, apiParams)

//更新delivery订单信息
export const updateDeliveryOrder = (apiName, apiParams) => post(apiBasicUrl + apiName, apiParams)

//updateTakeawayOrder
export const updateTakeawayOrder = (apiName, apiParams) => post(apiBasicUrl + apiName, apiParams)

//更新delivery.driver信息
export const getOrderDriverInfo = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)

//delivery配送待页面
export const getDeliveryProcessInfo = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)

//getMerchantList 获取连锁店基础信息
export const getChainstoreInfo = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)

//getMerchantList 获取连锁店信息列表
export const getMerchantList = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)

//getMerchantList 获取连锁店页面底总信息
export const getPageFooterInfo = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)

//updateEasypacelRetechecking 保存已选中的物流方式信息
export const updateEasypacelRetechecking = (apiName, apiParams) => post(apiBasicUrl + apiName, apiParams)

//makeOrderPayment
export const makeOrderPayment = (apiName, apiParams) => post(apiBasicUrl + apiName, apiParams)